import { Stack } from '@mui/material';
import React, { useState } from 'react';
import FoldedContractorPanel from './foldedContractorPanel';
import EditContractorPanel from './editContractorPanel';
import ContractorSummaryPanel from './contractorSummaryPanel';
import { useImmer } from 'use-immer';
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';

export default function ContractorPanel(props) {
  const ref = React.useRef();
  const id = props.id ?? 'contractorpanel';

  const searchEnabled = props.searchEnabled ?? false;
  const searchHelpText = props.searchHelpText ?? '';
  const searchFieldLabel = props.searchFieldLabel;

  const enableAddModeWhenNotFilled = props.enableAddModeWhenNotFilled ?? false;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [displaySummary, setDisplaySummary] = useState(false);
  const [editDisabled, setEditDisabled] = useState(true);
  const [buttonLabel, setButtonLabel] = useState('Edytuj');


  const [data, setData] = useImmer({ ...props.data });
  const [outerNip, setOuterNip] = useState(data?.nip?.nip);
  const [dataValidation, setDataValidation] = useState({ ...props.dataValidation });

  const openEditPopover = () => {
    setOpen(true);
    setAnchorEl(ref.current);
  };

  const editButtonClick = (event) => {
    setData((draft) => {
      if(dataValidation === true) draft.nip.nip = outerNip;
      else if(draft.name == '') draft.name = outerNip;
    });

    openEditPopover();
  };

  const onContractorChanged = (event, buyerData, buyerId) => {
    setOuterNip(buyerData.nip.nip);
    props.onContractorChanged(event, buyerData, buyerId);
  };

  const onNipValueChanged = (value) => {
    setOuterNip(value);

    if (value.trim() !== '') {
      setEditDisabled(false);
    } else {
      setEditDisabled(true);
    }
  };

  React.useEffect(() => {
    setData(props.data);
    setOuterNip(props.data.nip.nip);

    if (props.data.nip.nip !== '') {
      setEditDisabled(false);
      setDisplaySummary(true);
    } else if (!props.data.isCompany) {
      setEditDisabled(false);
      setDisplaySummary(true);
    } else {
      setEditDisabled(true);
      setDisplaySummary(false);
    }

    if(props.data.temporary == true) {
      editButtonClick();    // show edit popup if temporary contactor
    }
  }, [props.data]);

  React.useEffect(() => {
    if(enableAddModeWhenNotFilled && outerNip !== '' && props.data.nip.nip === '' && props.data.name === '') {
      setButtonLabel('+Dodaj');
    } else {
      setButtonLabel('Edytuj');
    };
    
  }, [outerNip, props.data]);

  return (
    <MDBox ref={ref} sx={{ flex: 1 }}>
      <Stack spacing={1} alignItems="flex-start">
        <FoldedContractorPanel
          id={id}
          title={props.title}
          value={outerNip}
          error={props.dataValidation}
          searchEnabled={searchEnabled}
          searchHelpText={searchHelpText}
          searchFieldLabel={searchFieldLabel}
          onValueChanged={onNipValueChanged}
          onContractorChanged={onContractorChanged}
          onValidationChanged={setDataValidation}
        />
        {props.children}
        <MDButton
          id={id + '-edit-button'}
          variant="text"
          color="info"
          disabled={editDisabled}
          onClick={editButtonClick}
        >
          {buttonLabel}
        </MDButton>
      </Stack>
      {displaySummary ? <ContractorSummaryPanel data={props.data} sx={{ ml: 1 }} /> : <React.Fragment></React.Fragment>}
      {open ? (
        <EditContractorPanel
          id={id}
          title={props.title}
          data={data}
          anchorEl={anchorEl}
          onContractorChanged={onContractorChanged}
          onCloseClick={() => {
            setAnchorEl(null);
          }}
        />
      ) : (
        <React.Fragment></React.Fragment>
      )}
    </MDBox>
  );
}
